<chart [dataSet]="chartData" (onClick)="bubbleClick($event)" chartType="horizontalBar" width="90%" [chartLabels]="[]" [plugins]="chartPlugins" [configuration]="extendedConfiguration" [options]="chartOptions"></chart>
